import type { IRegisterMapProps } from "@/sync/syncTypes"
import consola from "consola"

export const LiveCallsMapHandler = (name: string): IRegisterMapProps => ({
  name,
  onFailure: (error: unknown) => {
    consola.error(`Map ${name} failed`, error)
  },
  onRemoved: () => {
    consola.debug(`Map removed: ${name}`)
  },
  onItemAdded: (data: unknown, rawData: unknown) => {
    consola.debug(`Item added to ${name}`, data, rawData)
  },
  onItemRemoved: (data: unknown, rawData: unknown) => {
    consola.debug(`Item removed from ${name}`, data, rawData)
  },
  onItemUpdated: (data: unknown, rawData: unknown) => {
    consola.debug(`Item updated in ${name}`, data)
  },
})
